"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// prettier-ignore
exports.default = {
    "accountNumber": "SA0613",
    "name": "1000 Super",
    "type": "Super",
    "benefits": {
        "deathInsuredAmount": 200000,
        "totalPermanentDisabilityInsuredAmount": 200000,
        "preservationComponentPreservedAmount": 100000,
        "preservationComponentRestrictedNonPreservedAmount": 101544,
        "preservationComponentUnrestrictedNonPreservedAmount": 15646545,
        "taxationComponentEligibleServiceDate": "2022-10-04T00:00:00",
        "taxationComponentTaxFreeComponentAmount": 100000,
        "taxationComponentTaxableComponentUntaxedAmount": 1575,
        "taxationComponentTaxableComponentTaxedAmount": 456456
    },
    "pensionDetails": null,
    "beneficiaries": [
        {
            "name": "Chantal  Surname",
            "relationship": "CHILD",
            "nominationType": "Non Binding",
            "percentage": 33
        }
    ],
    "insurances": [
        {
            "deathInsuredAmount": 200000,
            "incomeProtectionInsuredAmount": 0,
            "premiumAmount": 87.75,
            "premiumFrequency": "Monthly",
            "totalPermanentDisabilityInsuredAmount": 200000
        }
    ]
};
